import { memo } from "react";
import fixedEncodeURIComponent from "../../helper/encodeUri";

const FacilityTitle = memo(({slug,name})=>{
    return(
          <h3 className="info-block-list__title">
            <a target="_blank" rel="noopener noreferrer" 
               href={`${window.initialState.locationUrl}/${fixedEncodeURIComponent(slug)}`}>
                {name}
            </a>
        </h3>
    )
})
export default FacilityTitle;